import { IConfig, ForloebClient, ForloebModel, IForloebModel } from '../../../api';

const forloebClient = new ForloebClient(new IConfig());

export const updateCourse = (course: IForloebModel) => {
	const forloeb = new ForloebModel(course);

	return forloebClient.update(forloeb);
};
